import Alert from '~store/Alert/Alert';
import { TimelineSpan } from './timeline.utils';

/** When a closed alarm ended, or null while it is still running. */
export function closedTime(alert: Alert) {
  if (!alert.isResolved) return null;
  const lastUpdate = alert.alertUpdateEvents.reduce<Date | null>(
    (latest, event) => (!latest || event.created > latest ? event.created : latest),
    null
  );
  return (alert.resolvedTime ?? alert.cancelledTime ?? lastUpdate ?? alert.created).getTime();
}

/** From the moment an alarm triggered until it was resolved or cancelled, open-ended while it runs. */
export function alarmWindow(alert: Alert): TimelineSpan {
  return { start: alert.created.getTime(), end: closedTime(alert) ?? Infinity };
}
